import React, { FC } from 'react'
import Modal from '../../../components/common/Modal'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'
import MemberList from './MemberList'

interface Props {
  detail: {
    member_id: number
    member_name: string
    year: string
  }
  isDisplay: boolean
  closeCallback: () => void
}

const MemberModal: FC<Props> = (props) => {
  const {
    detail,
    isDisplay,
    closeCallback,
  } = props

  const {
    report,
  } = useSelector((state: RootState) => (state))

  const closeModal = () => {
    closeCallback()
  }

  return (
    <Modal
      show={isDisplay}
      wrapperClass="member_modal list_box"
      closeCallback={closeModal}
      closeable
    >
      <MemberList
        reports={report.memberReportList?.reports || []}
        id={detail.member_id}
        name={detail.member_name}
        year={detail.year}
      />
    </Modal>
  )
}

export default MemberModal
